import React, { useMemo } from 'react';
import styles from './assetsformpage.module.css';

/**
 * Preview simplificado de texto:
 * - usa placeholders para tokens
 * - aplica alinhamento e shrink simples com CSS
 */
export default function TextPreview({ item }) {
  const { content, style } = item || {};
  const align = (style?.align || 'left');

  const placeholder = useMemo(() => {
    if (!content) return 'Texto';
    if (content.mode === 'token') {
      if (content.key === 'participant.name') return 'Nome do Participante';
      if (content.key === 'report.date') {
        // data simulada
        const d = new Date();
        const dia = String(d.getDate()).padStart(2,'0');
        const mes = String(d.getMonth()+1).padStart(2,'0');
        const ano = d.getFullYear();
        return `${dia}/${mes}/${ano}`;
      }
      return content.key;
    }
    if (content.mode === 'static') return String(content.value || 'Texto');
    return 'Texto';
  }, [content]);

  return (
    <div
      className={styles.textPreview}
      data-align={align}
      title={placeholder}
    >
      <span className={styles.textPreviewInner}>{placeholder}</span>
    </div>
  );
}